
module.exports = function() {
    return function(input, digits) {
        return  parseFloat(input.toFixed(digits));
    };
}